module.exports = __webpack_public_path__ + "img/gb-whatsapp-pro-other-features.0593c84d.webp";